import { createFileRoute } from '@tanstack/react-router'
import { ChannelPage } from '../../components/channel-page'

// Permalink: the channel anchored on one message (DIS-44).
export const Route = createFileRoute('/_app/c/$slug_/$messageId')({
  validateSearch: (s: Record<string, unknown>): { thread?: string } => (typeof s.thread === 'string' ? { thread: s.thread } : {}),
  component: () => {
    const { slug, messageId } = Route.useParams()
    const { me } = Route.useRouteContext()
    return <ChannelPage slug={slug} me={me} anchorId={messageId} />
  },
})
